import DetailPageContent from './components/detailPageContent';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";

export const NailCommissionPage = () => {
    return (
        <>
            <PageLayout>
                <PageContainer>
                    <PageBody>
                        <NavigationHeader></NavigationHeader>
                        <DetailPageContent>
                            <PageText>
                                <Container fluid className={'NailCommissionPageContent'}>
                                    <Row className={'row'}>
                                        <Col sm className={'colTitle'}>
                                            <a className={'navTitle'}> odd nails</a>
                                            <a className={'subTitle'}> because the odd ones always leave an
                                                impression </a>
                                        </Col>
                                    </Row>

                                    <Row className={'NailCommissionPage-row'}>
                                        <Col sm className={'NailCommissionPage-col'}>
                                            <div className={'NailCommissionPage-ImageWrapper'}>
                                                <img className={'NailCommissionPage-Image'} src={require("../images/MiffyClicked.png")} alt={""}></img>
                                            </div>
                                            <div className={'NailCommissionPage-TextWrapper'}>
                                                 <a className={'NailCommissionPage-Text'} href="https://forms.gle/dZzkgGPmD9CiGAK36">CUSTOM </a>
                                            </div>
                                        </Col>
                                        <Col sm className={'NailCommissionPage-col'}>
                                            <div className={'NailCommissionPage-ImageWrapper'}>
                                                <img className={'NailCommissionPage-Image'} src={require("../images/MiffyClicked.png")} alt={""}></img>
                                            </div>
                                            <div className={'NailCommissionPage-TextWrapper'}>
                                                <a className={'NailCommissionPage-Text'} href="https://forms.gle/dZzkgGPmD9CiGAK36">PREMADE </a>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </PageText>
                            <PageFooter />
                        </DetailPageContent>
                    </PageBody>
                </PageContainer>
            </PageLayout>
        </>
    )
}